import { sypToUsd, formatSypOnly, formatUsdForOrder, formatExchangeRate } from '../../utils/formatters';

/**
 * Renders order money as two clearly distinct lines instead of one run-on
 * string — bold "≈ 201.67 $" (USD reference) above a muted "3,025,000 ل.س"
 * (the actual charged amount) — so it's obvious at a glance which figure
 * is which. LTR-isolated for mixed scripts in RTL layouts.
 *
 * Pass `rate` (the order's own `exchangeRateSypPerUsd`) so the USD side
 * reflects the rate at checkout time rather than today's rate; omit it to
 * use the current live rate. The rate itself is shown once per order in
 * its own column/field (see Orders/Index.jsx and OrderDetails.jsx), not
 * repeated on every amount — pass `showRate` to opt back into an inline
 * rate line where there's no dedicated place for it.
 */
const DualCurrencyAmount = ({ amountSyp, locale = 'en', rate, showRate = false, className = '', style = {} }) => {
  const syp = Math.round(Number(amountSyp || 0));
  const usd = sypToUsd(syp, rate);

  return (
    <span
      dir="ltr"
      className={`dual-currency-amount ${className}`.trim()}
      style={{ whiteSpace: 'nowrap', unicodeBidi: 'isolate', ...style }}
    >
      <span className="dual-currency-primary">≈ {formatUsdForOrder(usd, locale)}</span>
      <span className="dual-currency-secondary">{formatSypOnly(syp, locale)}</span>
      {showRate && <span className="dual-currency-rate">{formatExchangeRate(rate, locale)}</span>}
    </span>
  );
};

export default DualCurrencyAmount;
